export default class AppName {
  /* Get App Name */
  static get() {
    return this.getSessionStorage() ?? this.getLocalStorage();
  }

  /* Get App Name from Session Storage */
  static getSessionStorage() {
    return JSON.parse(self.sessionStorage.getItem('appName'));
  }

  /* Get App Name from Local Storage */
  static getLocalStorage() {
    return JSON.parse(self.localStorage.getItem('appName'));
  }

  /* Set App Name */
  static set(val) {
    this.setSessionStorage(val);
    this.setLocalStorage(val);
  }

  /* Set App Name in Session Storage*/
  static setSessionStorage(val) {
    self.sessionStorage.setItem('appName', JSON.stringify(val));
  }

  /* Set App Name in Local Storage */
  static setLocalStorage(val) {
    self.localStorage.setItem('appName', JSON.stringify(val));
  }
}
